import { apiGet } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type {
  NotificacaoGlobal,
  NotificacaoGlobalDetalhe,
  NotificacoesGlobaisStatsParams,
} from '../../types/operacoes';

const BASE_URL = '/admin/notificacoes';

export interface NotificacoesGlobaisParams {
  page?: number;
  limit?: number;
  search?: string;
  escritorioId?: string;
  criadoPorId?: string;
  status?: string;
  periodo?: string;
  sortBy?: string;
  sortOrder?: string;
}

export interface NotificacoesGlobaisStats {
  total: number;
  enviadas: number;
  falhas: number;
  visualizadas: number;
}

export interface NotificacoesGlobaisListResponse {
  data: NotificacaoGlobal[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const notificacoesGlobaisService = {
  async list(params: NotificacoesGlobaisParams = {}): Promise<NotificacoesGlobaisListResponse> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (params.escritorioId) query.set('escritorioId', params.escritorioId);
    if (params.criadoPorId) query.set('criadoPorId', params.criadoPorId);
    if (params.status) query.set('status', params.status);
    if (params.periodo) query.set('periodo', params.periodo);
    if (params.sortBy) query.set('sortBy', params.sortBy);
    if (params.sortOrder) query.set('sortOrder', params.sortOrder);

    const qs = query.toString();
    const url = qs ? `${BASE_URL}?${qs}` : BASE_URL;
    const response = await apiGet(url);
    return parseApiResponse<NotificacoesGlobaisListResponse>(response);
  },

  async getStats(params: NotificacoesGlobaisStatsParams = {}): Promise<NotificacoesGlobaisStats> {
    const query = new URLSearchParams();
    if (params.escritorioId) query.set('escritorioId', params.escritorioId);
    if (params.criadoPorId) query.set('criadoPorId', params.criadoPorId);
    if (params.periodo) query.set('periodo', params.periodo);
    const qs = query.toString();
    const url = qs ? `${BASE_URL}/stats?${qs}` : `${BASE_URL}/stats`;
    const response = await apiGet(url);
    return parseApiResponse<NotificacoesGlobaisStats>(response);
  },

  async getById(id: string): Promise<NotificacaoGlobalDetalhe> {
    const response = await apiGet(`${BASE_URL}/${id}`);
    return parseApiResponse<NotificacaoGlobalDetalhe>(response);
  },
};
